import { getAxiosInstanceApi, getAxiosMultiPartInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Badge routes
 * ----------------------------
 */
export const getBadge = (query, force = false, callback) => {
    cachiosInstance.get(`/badge?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getBadgeCategory = (callback) => {
    cachiosInstance.get(`/badge-category`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};

export const newBadge = (formData, callback) => {
    getAxiosMultiPartInstanceApi().post(`/badge`, formData)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const newBadgeCategory = (formData, callback) => {
    getAxiosMultiPartInstanceApi().post(`/badge-category`, formData)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateBadgeCategory = (badgeCategoryId, formData, callback) => {
    getAxiosMultiPartInstanceApi().post(`/badge-category/${badgeCategoryId}?_method=PUT`, formData)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateBadge = (badgeId, formData, callback) => {
    getAxiosMultiPartInstanceApi().post(`/badge/${badgeId}?_method=PUT`, formData)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const deleteBadge = (badgeId, callback) => {
    getAxiosInstanceApi().delete(`/badge/${badgeId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const deleteBadgeCategory = (badgeCategoryId, callback) => {
    getAxiosInstanceApi().delete(`/badge-category/${badgeCategoryId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};